import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ChangePasswordByLink, IAuftragTableOrder, IChangePassword, IProfileResponseDto, IProfileSettings, NewProfile } from "../types/Types";

/**
 * @author mb
 */
export const ProfileAPI = createApi({
    reducerPath: "profileAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "profile",
            credentials: 'include'
        }),
    tagTypes: ['profileAPI'], // for caching
    endpoints: (builder) => ({
        requestPasswordResetMail: builder.mutation<void, string>(
            {
                query: (email: string) => ({
                    url: 'requestPasswordResetMail',
                    method: 'post',
                    params: {
                        email: email
                    },
                    credentials: 'include'
                })
            }
        ),
        changePasswordByLink: builder.mutation<void, ChangePasswordByLink>(
            {
                query: (
                    requestParams: ChangePasswordByLink
                ) => ({
                    url: `changePasswordByLink`,
                    method: 'PUT',
                    params: {
                        linkuid: requestParams.uid,
                        password: requestParams.password,
                        passwordRepeat: requestParams.passwordRepeat
                    },
                    credentials: 'include'
                })
            }
        ),
        register: builder.mutation<void, NewProfile>(
            {
                query: (dto) => ({
                    url: `register`,
                    method: 'post',
                    //credentials: 'include',
                    body: dto
                })
            }
        ),
        getOwnProfile: builder.mutation<IProfileResponseDto, void>(
            {
                query: () => ({
                    url: ``,
                    method: 'get',
                    credentials: 'include',
                })
            }
        ),
        getOwnTwoPhaseImage: builder.mutation<string, void>(
            {
                query: () => ({
                    url: `getOwnTwoPhaseImage`,
                    method: 'get',
                    credentials: 'include',
                    responseHandler: 'text',
                })
            }
        ),
        changePassword: builder.mutation<void, IChangePassword>(
            {
                query: (dto) => ({
                    url: `changePassword`,
                    method: 'put',
                    credentials: 'include',
                    body: dto,
                })
            }
        ),
        getAuftragTableOrderService: builder.mutation<any, string>(
            {
                query: (key) => ({
                    url: `getAuftragTableOrder/` + key,
                    method: 'get',
                    credentials: 'include',
                })
            }
        ),
        setAuftragTableOrderService: builder.mutation<any, IAuftragTableOrder>(
            {
                query: (dto) => ({
                    url: `setAuftragTableOrder`,
                    method: 'post',
                    credentials: 'include',
                    body: dto
                })
            }
        ),
        getProfileUpdateSettings: builder.mutation<IProfileSettings, void>(
            {
                query: () => ({
                    url: `getSettings`,
                    method: 'get',
                    credentials: 'include',
                })
            }   
        ),
        setProfileUpdateSettings: builder.mutation<void, IProfileSettings>(
            {
                query: (dto) => ({
                    url: `updateSettings`,
                    method: 'post',
                    credentials: 'include',
                    body: dto
                })
            }
        ),
    })
});

export const {

    useChangePasswordByLinkMutation,
    useRequestPasswordResetMailMutation,
    useRegisterMutation,
    useGetOwnProfileMutation,
    useGetOwnTwoPhaseImageMutation,
    useChangePasswordMutation,
    useGetAuftragTableOrderServiceMutation,
    useSetAuftragTableOrderServiceMutation,
    useGetProfileUpdateSettingsMutation,
    useSetProfileUpdateSettingsMutation,

} = ProfileAPI;
